<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="edi-guide-dialog"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BootHelperPage')"
    :close-on-click-modal="true"
    @close="onCancel"
  >
    <div class="main-content">
      <div :class="'tabs-container'">
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <div class="operations" style="margin-bottom: 5px;margin-top: 5px">
            <div class="triggers">
              <div class="btn-group-look">
                <el-button no="sendEdi" type="primary" @click="sendEdi">{{ $t('CargoMsg.Cargo_Send') }}</el-button>
                <el-button no="showEdi" type="primary" @click="showEdi">{{ $t('CargoMsg.Cargo_ViewingMessage') }}</el-button>
              </div>
            </div>
          </div>
          <el-tab-pane v-for="item in docList" :key="item.uuid" :label="item._name" :name="item._name">
            <edi-mbl-window :ref="item._name" :context="context" :action="action" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ediMblWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediMblWindow'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import lodash from 'lodash'
import { getLoading } from '@/utils/utilBaseElement'
import { getEDI, getFtpEDI, getLastEdiRecord, uploadEdiFile } from '@/api/seaExport/edi'
import * as EdiSendType from '@/class/cargo/model/parameters/EdiSendType'
import { parseTime } from '@/utils/index.js'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'

export default {
  name: 'EdiDocWindow',
  components: {
    ediMblWindow
  },
  props: {
    context: { type: Object, required: true },
    visible: { type: Boolean, required: true },
    globalVar: { type: Object, required: true },
    ediStatusName: { type: String, required: true },
    callBackFunc: { type: Function, required: false }
  },
  data() {
    return {
      loading: false,
      showButton: false,
      action: 'look',
      job: {},
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      JobUtils,
      SystemConstants,
      isLoadingData: false, // 是否正在加载数据
      canSave: true,
      nowGlobalVar: {},
      uploadEdiFileVo: {
        fileName: '',
        content: ''
      },
      params: {},
      docList: [],
      editEventFlag: false, // 编辑事件标识
      activeTabName: 'ediMblWindow',
      labState: '',
      defaultFileType: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  methods: {
    async showDetail(job, doc) {
      this.job = job
      this.form = lodash.cloneDeep(doc)
      this.nowGlobalVar = lodash.cloneDeep(this.globalVar)
      const docList = lodash.cloneDeep(this.job.cargoDoc)
      const docUuids = []
      for (const seDoc of docList) {
        if (seDoc.uuid && seDoc.edi && seDoc.docType === CargoDocConsts.MBL2) {
          seDoc._name = seDoc.mblNbr2 || seDoc.hblNbr2
          if (!docUuids.includes(seDoc.uuid)) {
            docUuids.push(seDoc.uuid)
            this.docList.push(seDoc)
          }
        }
      }
      this.form._name = this.job.jobNo
      this.docList.push(this.form)
      this.activeTabName = this.docList[0]._name
      this.$nextTick(() => {
        this.$refs[this.activeTabName][0].onShow(this.job, this.docList[0])
      })
    },
    onCancel() {
      this.$emit('close')
    },
    sendEdi() {
      const self = this
      const param = {}
      param.ediType = self.nowGlobalVar.ediType
      param.templateId = self.nowGlobalVar.ediTemplate.uuid
      param.jobUuids = self.nowGlobalVar.ediTemplateWin.uuids
      param.editStatus = self.nowGlobalVar.editStatus
      param.ruleEDINos = []
      self.loading = getLoading()
      getEDI(param).then(result => {
        self.loading.close()
        this.onSuccess(result)
      }).catch(message => {
        this.onExportEDIFail(message)
      }).finally(() => {
        if (self.loading) {
          self.loading.close()
        }
      })
    },
    // edi导出失败回调方法
    async onExportEDIFail(dataMsg) {
      if (dataMsg instanceof Error) {
        return
      }
      const modelMap = ModelMap['ProperyLabelMap']
      const errorMsgArr = dataMsg ? dataMsg.split(';') : null
      let finalMessage = ''
      const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
      if (errorMsgArr && errorMsgArr.length > 0) {
        errorMsgArr.forEach(errorMsg => {
          const modelField = errorMsg.split('.')
          if (modelField && modelField.length > 0) {
            const model = modelMap[modelField[0]]
            if (model) {
              finalMessage += (model[modelField[1]] + suffixMsg)
            }
          } else {
            finalMessage += errorMsg
          }
        })
      }
      if (finalMessage) {
        this.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
      } else {
        this.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
      }
    },
    async onSuccess(response) {
      const self = this

      if (!response || !response.data || JSON.stringify(response.data) === '{}') {
        this.$message.warning(this.$t('SeaExport.NoImportEDI'))
        return
      }

      const ediDatas = response.data
      const tabs = []
      for (const key in ediDatas) {
        if (key === 'ediTextManifestInfoUUIDs' || key === 'sendVersion') {
          continue
        }
        if (key === 'defaultFileType') {
          this.defaultFileType = ediDatas['defaultFileType']
        }
        if (key !== 'encode') {
          tabs.push({
            id: key,
            name: key,
            content: ediDatas[key]
          })
        }
      }
      this.nowGlobalVar.ediDatas = response.data
      this.params = {
        job: self.nowGlobalVar.selectedJob,
        title: self.nowGlobalVar.title,
        ediType: self.nowGlobalVar.ediType,
        ediCollection: self.nowGlobalVar.ediDatas,
        ediTemplate: self.nowGlobalVar.ediTemplate,
        ediStatusName: self.ediStatusName
      }
      // 判断最后一个记录是否是列队中
      const continueExec = await this.checkLastEdiState(this.params.job.uuid, this.params.ediType)
      if (!continueExec) {
        this.$message.warning(this.$t('SeaExport.HasBillExist', [this.params.job.jobNo]))
        return
      }

      await this.$confirm(this.$t('SeaExport.UploadEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'info' })
      const content = tabs.find(tab => tab.id === this.activeTabName).content

      this.uploadEdiFileVo.fileName = this.$t('SeaExport.Send')
      this.uploadEdiFileVo.content = content
      const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
      const sendFilePrefix = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendFilePrefix
      const ediObj = {}
      ediObj['templatePath'] = !this.params.ediTemplate ? '' : this.params.ediTemplate.templatePath
      ediObj[this.activeTabName] = content
      let ediSendType = 0
      if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
        ediSendType = EdiSendType.EDI_ORIGINAL_FTP_SEND.code
      } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
        ediSendType = EdiSendType.EDI_UPDATE_FTP_SEND.code
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediObj,
        sendType: sendType,
        sendFilePrefix: sendFilePrefix,
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : '',
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        ediSendType: ediSendType,
        uploadFileVo: JobUtils.assemblyParametersForUploadFileOfSendEdi(this.params, this.defaultFileType, 2, content)
      }
      self.loading = getLoading()
      setTimeout(() => {
        getFtpEDI(data).then(result => this.onFtpEDISuccess(result, data)).finally(() => { self.loading.close() })
      }, 4000)
    },
    onFtpEDISuccess(result, data) {
      if ((this.params.ediType === EdiType.BOOKING_EDI_TYPE.code || this.params.ediType === EdiType.BILL_EDI_TYPE.code) && result.data && !result.data.isSuccess) {
        this.$confirm(this.$t('SeaExport.CurrentNetworkChannelUnstable'), this.$t('SeaExport.EdiTips'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          data.retrySize = 1
          getFtpEDI(data).then(res => { })
        }).catch((e) => {
          this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
        })
        return
      } else if (result.data && result.data.uploadResult) {
        this.$message.info(this.$t('SeaExport.UploadEDISucceeded'))
        this.$emit('uploadSuccess', true)
        return
      }
      this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
    },
    /**
     * 判断最后一个记录是否是列队中
     * @returns
     */
    async checkLastEdiState(jobUuid, ediType) {
      let contnueExec = true
      if ((ediType === EdiType.BOOKING_EDI_TYPE.code || ediType === EdiType.BILL_EDI_TYPE.code)) {
        const loading = getLoading()
        await getLastEdiRecord({ jobUuid: jobUuid, type: ediType }).then(res => {
          if (res.data && res.data.bookingState && (res.data.bookingState === SystemConstants.JOB_BOOKING_IN_QUEUE.code || res.data.bookingState === SystemConstants.JOB_BILL_IN_QUEUE.code)) {
            contnueExec = false
          }
        }).finally(() => loading.close())
      }
      return contnueExec
    },
    // 上传文件至云存储
    // button 0 默认未知, 1 导出本页EDI,2 上传本页EDI, 3 上传所有EDI, 4 邮件上传EDI
    uploadFileToStorage(button = 0, originalFile = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')) {
      const uploadEdiFileVo = this.uploadEdiFileVo
      if (!this.uploadEdiFileVo.content) return
      const ediType = this.params.ediType
      if (ediType > 0 && [1, 2, 3, 4, 6, 7, 8, 11, 15, 30, 23, 26, 27, 43].includes(ediType)) {
        let documentType = ''
        switch (ediType) {
          case 1 : // 订舱
            documentType = 'BOOKING_EDI'
            break
          case 2 : // 提单
            documentType = 'LADING_BILL_EDI'
            break
          case 4 : // 安装箱
            documentType = 'INSTALL_EDI'
            break
          case 6 : // 预配舱单
            documentType = 'PRECONFIGURE_SHIPPING_EDI'
            break
          case 7 : // 清洁舱单
            documentType = 'IFCSUM_EDI'
            break
          case 8 : // 反恐舱单
            documentType = 'JP24SMF_EDI'
            break
          case 11 : // VGM
            documentType = 'VGM_EDI'
            break
          case 3 : // 海外代理预报
          case 15 : // 海外代理预报(包括CargoWise和荆艺接口)
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          case 30 : // 提箱
            documentType = 'SUITCASE_TYPE_EDI'
            break
          case 23 : // VGM
            documentType = 'VGM2_MANIFESTINFO_EDI'
            break
          case 26 : // 预配舱单-MANIFESTINFO方式
            documentType = 'PRECONFIGURE_MANIFESTINFO_SHIPPING_EDI'
            break
          case 27 : // 清洁舱单-MANIFESTINFO方式
            documentType = 'IFCSUM_MANIFESTINFO_EDI'
            break
          case 43 : // JCL预报
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          default:
            return null
        }
        if (documentType) {
          const params = {}
          params.fileType = this.getExportFileFix()
          params.createdBy = String(this.$store.getters.userInfo.userId)
          const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
          const sendTypeItem = ChargeItemTarget.getChargeItemTargetByCode2(sendType)
          params.fileSource = (sendTypeItem && sendTypeItem.code) ? sendTypeItem.code : ''
          params.documentType = documentType
          // 文件名
          if (this.params.hasOwnProperty('ediStatusName') && this.params.ediStatusName) {
            uploadEdiFileVo.fileName = this.getButtonName(button) + this.params.ediStatusName + '_' + originalFile + this.getExportFileFix()
          } else {
            uploadEdiFileVo.fileName = uploadEdiFileVo.fileName + this.getExportFileFix()
          }
          params.uuid = encodeURIComponent(this.params.job.uuid)
          params.jobNo = this.params.job.jobNo
          uploadEdiFileVo.params = params
          uploadEdiFile(uploadEdiFileVo).then().catch()
        }
      }
    },
    getExportFileFix() {
      const ediTemplate = this.params.ediTemplate
      if (!ediTemplate || !ediTemplate.defaultFileType) {
        return this.defaultFileType ? this.defaultFileType : '.data'
      }
      return ediTemplate.defaultFileType
    },
    getButtonName(button) {
      if (button === 1) {
        return this.$t('CargoMsg.Cargo_DataExport')
      } else if (button === 2 || button === 3) {
        return this.$t('SeaExport.Send')
      } else if (button === 4) {
        return this.$t('SeaExport.MailSending')
      }
    },
    showEdi() {
      this.callBackFunc(this.globalVar.ediTemplate)
    },
    handleTabClick(e) {
      this.$nextTick(() => {
        this.$refs[this.activeTabName][0].onShow(this.job, this.docList[e.index])
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.edi-guide-dialog {
  display: flex;
  height: 750px;
  width: 1085px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .el-dialog__body {
    height: 100%;
  }
}
</style>
